import React, { useState } from 'react'
import './AppFormItem.less'
import api, { MetadataOption } from 'api'
import { Radio } from 'antd'

export interface AppRadioProps {
	value?: string
	onChange?: (value: string, text: string) => void
	options?: MetadataOption[]
	readonly?: boolean
}

const getText = (value?: string, options?: MetadataOption[]) => {
	let option = options.find(o => o.value === value) || { label: '' }
	return option.label || ''
}

const getOptions = (options?: MetadataOption[]) => {
	if (options) {
		return options.map((option: MetadataOption) => {
			return { label: option.label || '', value: option.value || '' }
		})
	}
	return [{ label: '是', value: '1' }, { label: '否', value: '0' }]
}

export const AppRadio = (props: AppRadioProps) => {
	const [value, setValue] = useState(props.value)

	const onChange = (e: any) => {
		let newValue = e.target.value
		props.onChange && props.onChange(newValue, getText(newValue, props.options))
		setValue(newValue)
	}

	return (
		<div
			style={{
				// border: '1px solid',
				height: '30px',
				// display: 'flex',
				justifyContent: 'center',
				// alignItems: 'center',
			}}
		>
			<Radio.Group
				options={getOptions(props.options)}
				value={value}
				disabled={props.readonly || false}
				onChange={onChange}
			/>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppRadio.tsx